import { POPDFLabelSectionEditor } from '@webapp/modules/purchasing/features/get-po-pdf-label-set-fields/views/POPDFLabelSectionEditor'
import {
  type PDFLabelFieldMetadata,
  type PDFLabelSet,
} from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import { usePOPDFLabelSetFieldsPresenter } from './usePOPDFLabelSetFieldsPresenter'

export interface IPOPDFLabelSetFieldsPresenterProps {
  /** The active set — selection state is owned by the Feature Set. */
  labelSet: PDFLabelSet
  /** Delegates the whole-translation PUT to save-po-pdf-label-overrides. */
  onOverrideCommit: (
    translationType: PDFLabelFieldMetadata['translationType'],
    fieldKey: string,
    value: string
  ) => void
}

export const POPDFLabelSetFieldsPresenter = ({
  labelSet,
  onOverrideCommit,
}: IPOPDFLabelSetFieldsPresenterProps) => {
  const {
    data: { sections },
    states: { expandedSections },
    methods: { onToggleSection, handleOverrideChange, handleOverrideCommit },
  } = usePOPDFLabelSetFieldsPresenter({ labelSet, onOverrideCommit })

  return (
    <POPDFLabelSectionEditor
      sections={sections}
      expandedSections={expandedSections}
      onToggleSection={onToggleSection}
      onOverrideChange={handleOverrideChange}
      onOverrideCommit={handleOverrideCommit}
    />
  )
}

POPDFLabelSetFieldsPresenter.displayName = 'POPDFLabelSetFieldsPresenter'
